import { format } from 'date-fns';

import { useTranslation } from '#/features/localization/utils';

import Title from '#/components/common/toast/Title';
import Error from '#/components/common/toast/Error';

import { Liquidation } from '#/api/liquidations';

interface LiquidationProps {
  liquidation: Liquidation;
}

export function AccountIsBeingLiquidated() {
  const { t } = useTranslation();
  return (
    <Error>
      <Title>{t('Account in liquidation')} </Title>
      {t(
        'Account is being liquidated. Any open positions will be closed. Trading now is disabled.',
      )}
    </Error>
  );
}

export function AccountWasLiquidated(props: LiquidationProps) {
  const { liquidation } = props;
  const createdAt = format(liquidation.created_at, 'MMM dd, HH:mm');
  const { t } = useTranslation();

  return (
    <Error>
      <Title>{t('Account liquidated')}</Title>
      {t(
        'Your account was liquidated on {{createdAt}}. Any open positions were closed.',
        { createdAt },
      )}
    </Error>
  );
}
